import { getSubscriptions } from '@/api/subscriptions';
import { isCloudPlan } from '@/common/js/utils';
import { productsManager } from '@/lib';
import { SimpleAsyncProducerConsumer } from '@/utils/producerConsumer';
import { SingletonPromiseFactory } from '@/utils/synPromise';

export const fetchIsHadSubAndNotExpired = SingletonPromiseFactory( async () => {

    const [subs] = await Promise.all( [getSubscriptions( 'active' ), productsManager.update({})] );
    let cloudSubs = await Promise.all( subs.items.map( async item => {

        return {
            ...item,
            planInfo: await productsManager.getPlanById( item.plan )
        };

    }));
    cloudSubs = cloudSubs.filter( item => isCloudPlan( item.planInfo.series?.category ));
    if ( cloudSubs.length === 0 ) {

        return false;

    }
    const time = Date.now();

    // 有一个过期
    return !cloudSubs.some( sub => time > sub.expiredAt );

});

export const fetchIsHadSubAndNotExpiredProvider = new SimpleAsyncProducerConsumer( fetchIsHadSubAndNotExpired );
